/**
 * The Training log PDF button (plan docs/plans/lms-plan.md 7.5, 10.5; R16,
 * R24; WP-41): the per-person log a monitor or an inspector is handed (the
 * current completions, accepted external certificates, the history, open
 * assignments), generated on request and never stored. GET
 * /people/:userId/training-log.pdf streams it with Cache-Control: private,
 * no-store (WP-35), so it arrives as a Blob and is saved through an object URL
 * (api/certificates.ts downloadTrainingLog, saveBlob). A learner generates
 * their own; the route audits every generation.
 */
import { useState } from 'react';
import { FileDown } from 'lucide-react';
import { outlineBtnCls } from '../../../ui/styles';
import { useToast } from '../../../ui/Toast';
import { useAuth } from '../../../contexts/AuthContext';
import { apiErrorMessage } from '../../api/client';
import { downloadTrainingLog, saveBlob } from '../../api/certificates';

export function TrainingLogButton() {
  const { user } = useAuth();
  const { toast } = useToast();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    if (busy || !user?.id) return;
    setBusy(true);
    try {
      const { blob, filename } = await downloadTrainingLog(user.id);
      saveBlob(blob, filename);
      toast('Your training log was downloaded.', { type: 'success' });
    } catch (err) {
      toast(apiErrorMessage(err, 'The training log could not be generated. Try again.'), { type: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={outlineBtnCls()}
      onClick={() => void download()}
      disabled={busy || !user?.id}
      data-testid="lms-training-log"
    >
      <FileDown className="h-4 w-4" aria-hidden="true" />
      {busy ? 'Generating...' : 'Training log (PDF)'}
    </button>
  );
}

export default TrainingLogButton;
